// AyudaTecno HelpDesk — human-readable versioning (single source of truth)
//
// Scheme:  vMAJOR.MINOR "Codename" · build N
//   - MAJOR.MINOR + codename : curated here. Bump MINOR on a notable feature
//     batch, MAJOR + new codename when a real new era of the product lands.
//   - build N : total git commit count, injected by CI as REACT_APP_BUILD_NUMBER.
//     Retroactive by construction — commit #1 = build 1, today ≈ build 2525 —
//     so it always increases and needs zero bookkeeping.
//
// Codename theme: The Office characters. Each MAJOR == one real epoch of the
// product (reconstructed from git: first-appearance of the major modules).
// Reserved for the future: Pam (v4), and "Andy" saved for a special release.

export const VERSION = { major: 3, minor: 4, codename: 'Jim' };

// Retroactive era history (newest first). `key` -> i18n title/blurb in
// version.eras.<key>.* ; dates are real boundaries from the git history.
export const ERAS = [
  { major: 3, codename: 'Jim',     key: 'jim',     from: '2026-05',    to: null,         current: true },
  { major: 2, codename: 'Dwight',  key: 'dwight',  from: '2026-02-25', to: '2026-04' },
  { major: 1, codename: 'Michael', key: 'michael', from: '2026-02-19', to: '2026-02-24' },
];

// Approx commit count at last edit; CI overrides with the exact value. Used as a
// local-dev fallback so the pill still reads sensibly when the env var is absent.
const FALLBACK_BUILD = 2525;

export function getBuildNumber() {
  const env = process.env.REACT_APP_BUILD_NUMBER;
  const n = env ? parseInt(env, 10) : NaN;
  return Number.isFinite(n) && n > 0 ? n : FALLBACK_BUILD;
}

export function getCommit() {
  return process.env.REACT_APP_GIT_COMMIT || '';
}

export function getCommitTime() {
  return process.env.REACT_APP_GIT_TIME || '';
}

// 'v3.4 "Jim"'
export function formatVersion(v = VERSION) {
  return `v${v.major}.${v.minor} "${v.codename}"`;
}

// 'v3.4 "Jim" · build 2525'
export function formatVersionFull(v = VERSION) {
  return `${formatVersion(v)} · build ${getBuildNumber()}`;
}
